module.exports = __webpack_public_path__ + "static/media/japan.9e98e357.svg";